import React from 'react';
import { Link } from 'react-router-dom';

import './style.scss';
import { EntityId } from "@reduxjs/toolkit";

interface itemInterface {
  id: number;
  name?: string;
  title?: string;
  url: string;
  parent_id?: number | null;
  subcategories?: number[];
}

interface itemsInterface {
  [key: string]: itemInterface | undefined
}

interface propsInterface {
  items: itemsInterface | undefined;
  itemIds: EntityId[] | undefined;
  activeId: number | undefined;
  parent?: itemInterface;
}

const NavHorizontal = ({ parent, items, itemIds, activeId }: propsInterface) => {
  if (!items || !itemIds) {
    return null;
  }

  function name(item: any) {
    return item.name || item.title;
  }

  const RenderItem = ({ item, className }: any) => {
    let itemClass = `v-item ${className || ''}`;
    if (activeId === item.id || (item.isActive && item.isActive())) {
      itemClass += ' active';
    }

    return(
      <Link to={item.url} className={itemClass}>
        {name(item)}
      </Link>
    )
  }

  return (
    <div className='v-nav-horizontal'>
      <div className='v-nav'>
        {parent && <RenderItem key={parent.name} item={parent} className='o-parent' />}

        {
          itemIds.map(id => <RenderItem key={id} item={items[id]} />)
        }
      </div>
    </div>
  );
}

export default NavHorizontal;